import {useDebugValue} from 'react';

import {getNoUndefObject} from '../../../utils';

function useEvents(defaultEvents, ...otherEvents) {
    const specifiedEvents = otherEvents.reduce((accumulatedEvents, currentEvents) => ({
        ...accumulatedEvents,
        ...getNoUndefObject(currentEvents)
    }), {});

    const events = {
        ...defaultEvents,
        ...specifiedEvents
    };

    const result = {
        events
    };

    useDebugValue(result);

    return result;
}

export {useEvents};
